import React, { FC, ReactNode } from "react";
import { StyleButton, StyleButtonWrapper } from "./style";
import theme from "@utils/theme";
import Loader from "@components/loader";

interface ButtonProps {
  type?: "button" | "submit" | "reset";
  title: string;
  width?: number;
  height?: number;
  bg?: keyof typeof theme.colors;
  tc?: keyof typeof theme.colors;
  radius?: number;
  styleButton?: string;
  leftComponent?: ReactNode;
  rightComponent?: ReactNode;
  loading?: boolean;
  onClick?: (val: any) => void;
  icon?: any;
  justify?: string;
  variant?: string;
  disabled?: boolean;
}

const Button: FC<ButtonProps> = ({
  type = "button",
  title,
  leftComponent,
  rightComponent,
  loading = false,
  icon,
  justify,
  variant,
  disabled,

  ...restProps
}) => {
  return (
    <StyleButtonWrapper justify={justify}>
      <StyleButton
        type={type}
        {...restProps}
        variant={variant}
        disabled={loading || disabled}
      >
        {/* Inline simple loader */}
        {loading ? (
          <Loader size={10} color="white" />
        ) : (
          <>
            {icon && (React.isValidElement(icon) ? icon : typeof icon === "function" || typeof icon === "object" ? React.createElement(icon as any, { size: 18 }) : icon)}
            {leftComponent && leftComponent}
            {title}
            {rightComponent && rightComponent}
          </>
        )}
      </StyleButton>
    </StyleButtonWrapper>
  );
};

export default Button;
